import React from 'react';
import classnames from 'classnames';

export type AiSparkleIconProps = React.SVGProps<SVGSVGElement>;

/** Four-point sparkle used on AI Result badges (Sameeksha / Figma worklist). */
export function AiSparkleIcon({
  className,
  width = 12,
  height = 12,
  ...props
}: Readonly<AiSparkleIconProps>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="currentColor"
      className={classnames('shrink-0', className)}
      aria-hidden
      {...props}
    >
      <path d="M8 1.25c.18 2.55 1.35 4.35 3.75 5.25C9.35 7.4 8.18 9.2 8 11.75 7.82 9.2 6.65 7.4 4.25 6.5 6.65 5.6 7.82 3.8 8 1.25Z" />
      <path d="M12.75 2.1c.12 1.15.6 2 1.7 2.45-.95.45-1.43 1.3-1.55 2.45-.12-1.15-.6-2-1.7-2.45.95-.45 1.43-1.3 1.55-2.45Z" />
    </svg>
  );
}
